import React from 'react';
import { signOut } from '../../../../utils/extension';
import { Box, Button, Typography } from '@mui/material';

const NoPermission = ({ authorization = {}, isSingleCompany = true, email = '', onClick = () => {} }) => {
    return (
        <>
            <Box mt={3} display="flex" flexDirection="column" gap={2}>
                <Typography className="text-dark-blue font-roboto fw-500 font-base">
                    {!authorization?.hasSetup && 'Your company has not set up the Diolog email extension.'}
                    {authorization?.hasSetup &&
                        !authorization?.hasPermission &&
                        'You have not been given permission to access this extension.'}
                </Typography>
                <Typography className="text-dark-blue font-roboto font-normal">
                    {!authorization?.hasSetup &&
                        'Your company admin has not set up this extension on the Diolog web app. Please talk to the admin and check again.'}
                    {authorization?.hasSetup &&
                        !authorization?.hasPermission &&
                        'Company admin has not given you permission to use this extension. Please talk to the admin and check again once your permissions are updated.'}
                </Typography>
            </Box>
            {isSingleCompany ? (
                <Box justifySelf="center" alignSelf="center" mt={3}>
                    <Button
                        disableElevation
                        disableRipple
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        className="alternate-reversed"
                        onClick={() => {
                            signOut();
                            window.location.reload();
                        }}
                        marginTop={24}
                    >
                        Sign out
                    </Button>
                </Box>
            ) : (
                <Box mt={3} display="flex" alignItems="center" width="100%" gap={1} p={0}>
                    <Button
                        disableElevation
                        disableRipple
                        type="submit"
                        variant="contained"
                        className="alternate-reversed"
                        onClick={() => {
                            signOut();
                            window.location.reload();
                        }}
                    >
                        Sign out
                    </Button>
                    <Button
                        disableElevation
                        disableRipple
                        size="large"
                        type="submit"
                        variant="contained"
                        sx={{ paddingY: 1.2 }}
                        onClick={onClick}
                        className="text-dark-blue"
                    >
                        Choose another company
                    </Button>
                </Box>
            )}
        </>
    );
};

export default NoPermission;
